import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus, TrendingUp } from "lucide-react";
import { PipelineItem } from "./types";
import { PipelineView } from "./PipelineView";

import logger from '@/utils/logger';
const PipelineManagement: React.FC = () => {
  const [pipelineItems, setPipelineItems] = useState<PipelineItem[]>([]);

  const handleDeleteItem = (itemId: string) => {
    setPipelineItems(prev => prev.filter(item => item.id !== itemId));
  };

  const handleEditItem = (item: PipelineItem) => {
    // TODO: Implement edit functionality
    logger.info('Edit item:', item);
  };

  // Show import dialog if no data exists
  if (pipelineItems.length === 0) {
    return (
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Loan Pipeline</h1>
            <p className="text-muted-foreground">Manage your loan pipeline and track applications</p>
          </div>
        </div>

        <div className="flex items-center justify-center min-h-96">
          <div className="text-center space-y-6 max-w-md">
            <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto">
              <TrendingUp className="w-12 h-12 text-muted-foreground" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-foreground mb-2">No Pipeline Data</h2>
              <p className="text-muted-foreground mb-6">
                Get started by manually adding loans to your pipeline. Track applications, 
                manage statuses, and monitor your loan processing workflow.
              </p>
            </div>
            <div className="flex justify-center">
              <Button variant="outline" size="lg">
                <Plus className="w-4 h-4 mr-2" />
                Add Loan Manually
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Loan Pipeline</h1>
          <p className="text-muted-foreground">Manage your loan pipeline and track applications</p>
        </div>
        <div>
          <Button>
            <Plus className="w-4 h-4 mr-2" />
            Add Loan
          </Button>
        </div>
      </div>

      <PipelineView
        items={pipelineItems}
        onEditItem={handleEditItem}
        onDeleteItem={handleDeleteItem}
      />
    </div>
  );
};

export default PipelineManagement;